import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap, count } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectAttributesService {

  url = environment.url;

  constructor(public http: HttpClient) { }


  getProjectAttributes() {
   // console.log(" Get all project attributes");
    return this.http.get(`${this.url}` + '/project/getAllAttributes').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting project attributes'))),
    );
  }

  getAllLanguages() {
   // console.log("Get All languages");
    return this.http.get(`${this.url}` + '/project/getAllLanguages').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get All languages'))),
    );
  }


  getAllStatesByCountry(country) {
    // console.log("Get All states by country");
    // console.log(country)
    return this.http.get(`${this.url}` + '/states/states/' + country).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get all states by country'))),
    );
  }
}
